export const correctLocaleCasing = (locale?: string) => {
  if (!locale) {
    return '';
  }
  const localeParts = locale.split('-');
  if (localeParts.length === 1) {
    return localeParts[0].toLowerCase();
  }
  if (localeParts.length === 2) {
    return `${localeParts[0].toLowerCase()}-${localeParts[1].toUpperCase()}`;
  }
  return locale;
};
